import { useEffect, useState } from "react";
import axios from "axios";
import swal from "sweetalert";
import { Navigate, useNavigate } from "react-router-dom"; //Outlet,
import Loading from "./components/admin/childComponents/appComponents/Loading";
const SecureAdmin = () => {
  const BASE_URL = process.env.REACT_APP_API_BASE_URL || "";
  const navigate = useNavigate("");
  const [authenticated, setAuthenticated] = useState(false);
  const [loading, setloading] = useState(true);

  useEffect(() => {
  const checkAuth = async () => {
    try {
      let datas = "?encryption[eq]=" + localStorage.getItem("encryption");

      const res = await axios.get(BASE_URL + "checkingifsecured" + datas);

      if (res?.data?.status === 200) {
        localStorage.setItem("admin_authority", res.data.admin_authority);
        localStorage.setItem("admin_type", res.data.admin_type);
        localStorage.setItem("admin_status", res.data.admin_status);
        localStorage.setItem("admin_passport", res.data.admin_passport);
        localStorage.setItem("admin_signature", res.data.admin_signature);
        localStorage.setItem("NumberType", res.data.fileNumber);
        localStorage.setItem("admin_id", res.data.admin_id);
        localStorage.setItem("auth_name", res.data.admin_name);

        setAuthenticated(true);
      } else {
        swal("Oops!", res?.data?.message || "Error", "error");
      }

    } catch (error) {
      console.log("AUTH ERROR:", error);

      localStorage.removeItem("admin_passport");
      localStorage.removeItem("auth_token");
      localStorage.removeItem("admin_id");
      localStorage.removeItem("auth_name");
      localStorage.removeItem("admin_type");
      localStorage.removeItem("NumberType");
      localStorage.removeItem("debitGrandTotal");
      localStorage.removeItem("creditGrandTotal");
      localStorage.removeItem("admin_signature");
      localStorage.removeItem("newGrandTotal");
      localStorage.removeItem("grandTotal");
      localStorage.removeItem("admin_authority");
      localStorage.removeItem("admin_status");
      localStorage.removeItem("allGrandTotal");
      localStorage.removeItem("selectedSearch");
      localStorage.removeItem("encryption");
      localStorage.clear();
    } finally {
      setloading(false);
    }
  };

  checkAuth();
}, []);

  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      console.log("INTERCEPTOR ERROR:", error);

      if (error.response) {
        const status = error.response.status;

        if (status === 401) {
          swal(
            "Unauthorized Attempt! Logout!",
            error.response.data?.message || "Unauthorized",
            "warning",
          );
          navigate("/login");
        } else if (status === 403) {
          swal(
            "Forbidden!",
            error.response.data?.message || "Access denied",
            "warning",
          );
          navigate("/admin/dashboard");
        } else if (status === 404) {
          swal(
            "404 Error!",
            error.response.data?.message || "Not found",
            "warning",
          );
          navigate("/admin/dashboard");
        }
      } else if (error.request) {
        console.log("No response from server (network/CORS issue)");
      } else {
        console.log("Error:", error.message);
      }

      return Promise.reject(error);
    },
  );

  if (loading) {
    // Loading, Processing Payment, Please Dont Interrupt
    return <Loading message01={"Loading..."} />;
  }
  return !authenticated && <Navigate to="/login" />;
  //return authenticated ? <Outlet /> : <Navigate to="/login" />;
  /**/
};

export default SecureAdmin;
